import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { User } from '@macs-frontend/features/shared';

@Component({
  selector: 'md-dropdown-user-selected',
  templateUrl: 'dropdown-user-selected.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownUserSelectedComponent extends BaseComponent {
  @Input()
  // @ts-expect-error
  user: User;
}
